import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../Redux/hooks";
import { RootState } from "../../../../store";
import {
  fetchOrderById,
  clearCurrentOrder,
} from "../../../../Redux/custmoer_orders/slice";
import ChatPanel from "../../../../ecommerce/globalcomponents/ChatPanel/ChatPanel";
import FoodOrderTrackingModal from "./FoodOrderTrackingModal";
import "./FoodOrdersPage.css";
import "./FoodOrderTrackingModal.css";

const FoodOrderDetails = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { currentOrder } = useAppSelector(
    (state: RootState) => state.customerOrders,
  );

  const [chatOpen, setChatOpen] = useState(false);

  useEffect(() => {
    if (id) {
      dispatch(fetchOrderById(id));
    }
    return () => {
      dispatch(clearCurrentOrder());
    };
  }, [id, dispatch]);

  return (
    <div className="food-track-page">
      <FoodOrderTrackingModal
        open={true}
        onClose={() => navigate("/FoodOrderList")}
        onChat={() => setChatOpen(true)}
      />
      <ChatPanel
        open={chatOpen}
        onClose={() => setChatOpen(false)}
        order={currentOrder}
      />
    </div>
  );
};

export default FoodOrderDetails;
